import { IssueFormInDto } from 'shared/dtos/in/issueForm';
import { getOne } from 'serviceWorker/db/permissions';
import {
  defaultConfig,
  generateHeaders,
  parseResponse,
} from '../../helpers/httpRequests';
import { HeadersData } from '../factories/types';
import { pull } from '../pull';
import { IssueFormFetchResult, IssueFormSkipReason, skippedIssueFormFetch } from './issueFormFetchResult';
import { get as getSelectedProject } from 'serviceWorker/db/selectedProject';

type ParseFormResponse = () => Promise<IssueFormInDto[]>;

/** Expects `data` from ensureAuthenticatedConfig(), so the token is already fresh. */
export const fetchIssueForm = async (
  data: HeadersData,
  controller: AbortController
): Promise<IssueFormFetchResult> => {
  const { signal } = controller;
  if (shouldSkip(data, signal)) {
    return skippedIssueFormFetch(IssueFormSkipReason.notRequestable);
  }

  const selectedProject = await getSelectedProject();
  if (!selectedProject) {
    return skippedIssueFormFetch(IssueFormSkipReason.noSelectedProject);
  }
  const project = await getOne(selectedProject._id);
  if (!project) {
    return skippedIssueFormFetch(IssueFormSkipReason.permissionsNotStored);
  }
  const builtUrl = `${data.api}/v2/project/${data.projectId}/issueForm`;

  const issueForms = await pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  }).then(parseResponse as ParseFormResponse);
  return { isDownloaded: true, issueForms };
};

function shouldSkip(data: HeadersData, signal: AbortSignal): boolean {
  return !data.api || !data.projectId || signal.aborted;
}
